var map = {
	"./ap-1.png": 28679,
	"./ap-2.png": 43346,
	"./car.png": 42288,
	"./dot-icon-1.png": 74332,
	"./dot-icon-2.png": 77803,
	"./dot-icon-3.png": 3050,
	"./dot-icon-4.png": 47446,
	"./dot-icon-5.png": 26056,
	"./dot-icon-6.png": 43952,
	"./euro.png": 82043,
	"./hongkong.png": 72540,
	"./line-ex.png": 33360,
	"./line.png": 26026,
	"./map.png": 78548,
	"./pound.png": 11556,
	"./singapore.png": 58326,
	"./usa.png": 72773,
	"./yen.png": 32473
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48725;